import { HTMLProps, PropsWithChildren } from 'react';

import { Styles, css } from '@flipster/styled-system/css';

interface Props extends HTMLProps<HTMLDivElement> {
  highlight?: boolean;
  sectionType?: string;
  css?: Styles;
}

export const MaxWidthSection = ({
  sectionType,
  highlight,
  children,
  css: cssProps,
  ...restProps
}: PropsWithChildren<Props>) => {
  return (
    <section
      data-section-type={sectionType}
      className={css(
        { textStyle: 'Text/L/Regular', color: 'content.default.level-3' },
        highlight && { bgColor: 'gray.black' },
      )}
      {...restProps}
    >
      <div
        className={css(
          {
            px: 16,
            py: { base: 30, tablet: 60 },
            boxSizing: 'content-box',
            tablet: {
              maxWidth: 'desktopMaxWidth',
              mx: 'auto',
            },
          },
          cssProps,
        )}
      >
        {children}
      </div>
    </section>
  );
};
